import { Workspace } from '@local/client-contracts';
import { Constants } from '@local/common';
import { isMac } from '@local/common-web';

const os = isMac() ? 'Mac' : 'Windows';
const SECONDS_IN_DAY = 86400;
export const providersIconsMap = {
  Google: { type: 'img', value: { lightUrl: './assets/sso-providers/google.svg' } },
  AzureAd: { type: 'img', value: { lightUrl: './assets/sso-providers/azure.svg' } },
  Microsoft: { type: 'img', value: { lightUrl: './assets/sso-providers/microsoft.svg' } },
  Okta: { type: 'img', value: { lightUrl: './assets/sso-providers/okta.svg', darkUrl: './assets/sso-providers/okta-dark.svg' } },
  Slack: { type: 'img', value: { lightUrl: './assets/sso-providers/slack.svg' } },
};
export const content = {
  'delete-popup': {
    secondaryButton: 'Cancel',
    supportMail: 'support@unleash.so',
    primaryButton: 'Delete',
  },
  'my-profile': {
    personalInfo: 'Personal info',
    photo: 'Photo',
    emailAddress: 'Email address',
    userName: 'User name',
    deleteAccount: 'Danger zone',
    deleteButtonWarning: 'This will remove all of your data',
    deleteButtonMsg: 'Delete my account',
    canNotDeleteWorkspaces:
      'You can delete your account by contacting us via the chat widget found on the right hand corner of the app or popping us a message',
    deleteWorkspaceMessage: 'This action cannot be undone. This will permanently delete the account, and any associated data.',
    errorGeneralMessage: 'For some reason we could not fetch your general data',
    quickSearch: 'Quick search',
    windowType: 'Select which form of Unleash to use',
    keyboardShortcut: 'Keyboard shortcut',
    openApplication: 'Pull Unleash. Edit the keyboard shortcut that opens the Unleash Command Bar from any page on Unleash',
    launchUnleash: 'Launch Unleash on startup',
    launchUnleashText: 'Automatically launch Unleash when your computer starts',
    appVisibility: 'App Visibility',
    appVisibilityText: 'App Visibility',
    appearance: 'Appearance',
    appearanceText: 'Customize how Unleash looks on your device',
    browserExtension: 'Browser Extension',
    browserPinUnleash: 'Pin Unleash to browser',
    browserHomePage: 'Set Unleash as your new tab page',
    browserDial: 'Show Unleash Dial on websites',
    browserWindowStyle: 'Choose window style',
    nativeDial: 'Show Unleash Dial on desktop',
    pinUnleash: 'Pin Unleash to Taskbar',
    pinUnleashText: 'View Unleash in your taskbar',
    automaticallyHide: 'Automatically hide Unleash',
  },
  'app-upgrades': {
    devices: [
      {
        name: 'desktop',
        title: 'Unleash for Desktop',
        text: 'Access the full power of Unleash with the desktop app- featuring a spotlight-style launch bar for quick searches and desktop resource indexing for seamless navigation. ',
        svg: 'assets/bar/settings/desktop.svg',
        buttonText: 'Download now',
        buttonIcon: true,
        installed: 'Installed',
        buttonTextInstalled: 'Downloaded',
      },
      {
        name: 'chromeExtension',
        title: 'Unleash Extension',
        text: 'Streamline your workflow with Unleash search, chat, and AI-powered writing tools for instant answers,—right from your browser. Available for Chrome and Edge.',
        svg: 'assets/bar/settings/extension.svg',
        buttonText: 'Install extension',
        installed: 'Installed',
        buttonTextInstalled: 'Installed',
        buttonIcon: true,
        icon: 'chrome',
      },
    ],
    pc: {
      text: 'Allows you to search your local desktop content.',
    },
    bots: [
      {
        name: 'slack',
        displayName: 'Unleash for Slack',
        how_to_use: 'From any chat or channel type /u to find, open and share resources with colleagues.',
        image: {
          type: 'img',
          value: {
            lightUrl: '/assets/bar/results/share/slack_icon.svg',
          },
        },
      },
    ],
    tableCols: [
      { header: 'App', templateType: 'app' },
      { header: 'How to use', templateType: 'how_to_use' },
      { header: 'Status', templateType: 'status' },
      { header: ' ', templateType: 'installed' },
    ],
  },
  'workspace-general': {
    info: 'Info',
    icon: 'Icon',
    iconSubtitle: 'Upload your company’s logo. Square icons work best.',
    upload: 'Upload',
    imgOptions: 'Only png, jpeg, svg formats with max file size of 5 MB.',
    workspaceName: 'Workspace name',
    workspaceNameDescription: 'You can use your organization or company name. Keep it simple. ',
    landingPageTitle: 'Default page',
    landingPageDescription: 'Select the page users see when they open Unleash',
    landingPageOptions: [
      { value: 'chat', label: 'Chat', icon: { type: 'font-icon', value: 'icon-chat-dots' } },
      { value: 'search', label: 'Search', icon: { type: 'font-icon', value: 'icon-search-icon-fixed' } },
    ],
    dangerZone: 'Danger Zone',
    deleteWorkspace: 'Delete workspace',
    deleteDescription: 'If only 1 workspace available, every member will be automatically added to personal workspace',
    canNotDeleteWorkspaces: 'In order to delete this workspace please contact us by email: ',
    deleteWorkspaceMessage: 'This action cannot be undone. This will permanently delete the account, and any associated data.',
    leaveWorkspace: 'Leave Workspace',
    primaryButton: 'Leave',
    leaveWorkspacePopupMsg: 'Are you sure you want to leave this workspace?',
    imgErrorMsg: 'Upload failed. Please try again',
    errorGeneralMessage: 'For some reason we could not fetch your workspace settings',
    inputErrorMsg: 'Invalid workspace name.',
    workspaceId: 'Workspace ID',
    currentPlan: 'Current plan ',
    workspaceStatus: 'Workspace status',
    activePlan: 'Active',
    trialPlan: 'Trial',
    trialDaysLeft: 'Days left for trial',
    price: 'Price',
  },
  members: {
    searchPlaceholder: 'Search by email, name or app',
    searchPlaceholderMember: 'Search by email or name',
    user: 'User',
    connectedApps: 'Connected Apps',
    accessLevel: 'Access level',
    removeTitle: 'Remove from team',
    removeMemberMessage: 'Are you sure you want to remove this person?',
    primaryButton: 'Remove',
    admin: 'Admin',
    member: 'Member',
    owner: 'Owner',
    errorGeneralMessage: 'For some reason we could not fetch your members settings',
    inputErrorMsg: 'Invalid search',
  },
  'workspace-appearance': {
    bannerTitle: 'Homepage banner',
    bannerDescription1: 'This will be displayed as the banner image for all teammates in your workspace.',
    bannerDescription2: 'Only png, jpeg, svg. max file size of 5 MB',
    bannerCheckbox: 'Use same asset for all themes',
    colorsTitle: 'Colors',
    colorsDescription: 'These colors will be displayed as the default for all teammates in your workspace. ',
    primaryColor: 'Accent color',
    primaryTextColor: 'Text on accent color',
    sidebarBackgroundColor: 'Sidebar background color',
    sidebarTextColor: 'Text on sidebar color',
    vibrancyTitle: 'Enable Vibrancy',
    vibrancyDescription: 'Use vibrancy in side bar and in launcher (Restart app to apply the change)',
  },
  settings: {
    synonymsHeader: 'Synonyms',
    maxFileSize: 'Only CSV files are accepted. Maximum file size is 10MB',
    replaceFileRow1: 'If you wish to make any changes, replace the current file with an updated version.',
    synonymsHeadline: 'Create a synonyms CSV file and upload it to Unleash. This file should include two',
    fileProcessingError: 'File processing failed. Please contact us for assistance.',
    fileConflictError: 'File processing conflicts with another user. Please try refreshing the page.',
    saveFilterHeader: 'Default search filters',
    saveFilterHeadline: `Set your own default filters to streamline searches. Once enabled, they automatically apply in
                         full search on the App and Extension.`,
  },
  'removing-channel-popup': {
    showButtons: true,
    rightButtonStyle: { type: 'primary-danger', size: 80 },
    leftButtonStyle: { size: 80 },
    content: {
      secondaryButton: 'Cancel',
      primaryButton: 'Remove',
    },
    checkbox: {
      value: false,
      text: 'Do not show this again',
    },
    messageStyle: { fontSize: '14px' },
  },
  'toggle-warning-popup': {
    message: 'Toggling off this setting will </br> erase all pending invitations in </br> this section.',
    showButtons: true,
    rightButtonStyle: { type: 'primary', size: 100 },
    leftButtonStyle: { size: 100 },
    content: {
      secondaryButton: 'Cancel',
      primaryButton: 'Toggle off',
    },
    messageStyle: { fontSize: '14px' },
  },
  'workspace-assistant': {
    description:
      'Unleash AI uses your company’s connected data to answer work‑related questions in search and in the default workspace chat. You can add custom instructions to control how it responds to queries. These settings apply only to Unleash AI and won’t affect other assistants.',
    instructionsDynamicContent: {
      advancedTitle: "Provide clear instructions to customize Unleash's response.",
      advancedPlaceholder:
        'You are a helpful assistant that provides clear, accurate, and concise responses. Answer questions directly, using simple language and step-by-step instructions when needed. Maintain a friendly, professional tone at all times. Be detailed when necessary to ensure thorough understanding.',
      learnMoreUrl: `${Constants.RELEASE_NOTES_URL}assistants-1`,
    },
    unleashAiDisabled: 'Activate Unleash AI',
    unleashAiDisabledTooltip: 'When off, your workspace will not have access to AI-powered search or the default workspace Chat assistant',
    unleashAiCustomize: 'Customization',
    unleashAiCustomizeSubTitle: 'Customize your default workspace assistant. By default, these match your workspace’s name and icon.',
    unleashAiDefaultDescription: 'Chat and ask questions to uncover everything you want to know from your company’s knowledge base',
  },
  'addons-slack': {
    assistantsHeader: 'Slack Channel Assistant',
    assistantsHeadline: 'Allow members to create Slack Channel assistants',
    assistantsDisabledTooltip: 'Unleash app must be installed to create assistants',
  },
  'setup-extension': {
    title: 'AI Writing Tools',
    assistantDescription:
      'Select an LLM-powered chat assistant to enhance content while using the browser extension, accessible to all workspace members.',
    languageDescription: 'Default translation language ',
  },
  'preferences-extension': {
    languageTitle: 'AI Writing Tools',
    languageDescription: 'Your default translation language ',
  },
  'sign-in': {
    invitations: 'Invite users',
    invitePermissions: 'Invitation permission',
    blockUnknownDomains: 'Restrict invitations to workspace domain addresses only',
    inviteOptions: [
      {
        label: 'Only admins',
        value: 'admins',
      },
      {
        label: 'Nobody',
        value: 'nobody',
      },
      {
        label: 'Everybody',
        value: 'everybody',
      },
    ],
    claimDomain: 'Claim domain',
    claimDomainInfo:
      'Verified domains linked to your workspace allows users logging into Unleash with an email address from the domain list to automatically be added to your workspace.',
    signIn: 'User authentication setup',
    signInTitle: 'Single Sign On',
    emailAuthentication: 'Email Authentication (via Magic Link)',
    signInTimeout: 'Session duration:',
    timeoutOptions: [
      {
        label: 'Never expires',
        value: null,
      },
      {
        label: '90 days',
        value: 90 * SECONDS_IN_DAY,
      },
      {
        label: '60 days',
        value: 60 * SECONDS_IN_DAY,
      },
      {
        label: '30 days',
        value: 30 * SECONDS_IN_DAY,
      },
      {
        label: '14 days',
        value: 14 * SECONDS_IN_DAY,
      },
      {
        label: 'Week',
        value: 7 * SECONDS_IN_DAY,
      },
    ],
  },
  notifications: {
    notifications: 'Workspace notifications',
    notificationsInfo: 'Manage workspace alerts for shared source updates and changes',
    email: 'Email notifications',
    slack: 'Slack notifications',
    teams: 'Teams notifications',
    whoToNotify: 'Who to notify',
    whoToNotifyOptions: [
      { label: 'All admins', value: 'admins', title: 'Notify all workspace admins' },
      { label: 'Source owner', value: 'owner', title: 'Notify the owner of the source' },
      { label: 'Custom', value: 'custom', title: 'Select specific admins to notify' },
    ],
    customAdminsPlaceholder: 'Select admins',
    customAdminsFilterPlaceholder: 'Search for an admin',
    customAdminsSelectedInfo: 'Selected admins will be notified for all sources',
    alsoNotifySourceOwner: 'Also notify the source owner',
    notifyPrivateSourceOwner: 'Notify the source owner about private sources',
    whenToNotify: 'When to notify',
    syncFailed: 'Sync failed',
    expiredCredentials: 'Expired credentials',
    slackRecipientsInfo: 'Recipients are configured in each webhook.',
    slackConfigureWebhook: 'Configure webhook',
    slackWebhookPlaceholder: 'Paste Slack webhook URL',
    teamsWebhookPlaceholder: 'Paste Teams webhook URL',
    slackAddWebhook: 'Add webhook',
    slackRemoveWebhook: 'Remove webhook',
    teamsInfo: 'Teams notifications are managed separately.',
    adminRemovedAlert: 'One or more users are no longer admins and were removed',
  },
  'authentication-policy-popup': {
    signInOptions: ['SSO', 'SAML'],
    dropdownProviders: [
      {
        title: 'Okta',
        value: 'Okta',
        icon: providersIconsMap['Okta'],
      },
      {
        title: 'Azure',
        value: 'AzureAd',
        icon: providersIconsMap['AzureAd'],
      },
      {
        title: 'Google',
        value: 'Google',
        icon: providersIconsMap['Google'],
      },
    ],
    checkboxProviders: [
      { value: 'Google', image: providersIconsMap['Google'] },
      { value: 'Microsoft', image: providersIconsMap['Microsoft'] },
      { value: 'Slack', image: providersIconsMap['Slack'] },
    ],
    guideLink: {
      Okta: 'https://help.unleash.so/docs/okta-sso-and-scim',
      AzureAd: 'https://help.unleash.so/docs/microsoft-sso',
      Google: 'https://help.unleash.so/docs/google-sso',
    },
    metadataInput: {
      Okta: 'Paste the Identity Provider Metadata URL here <span class="mandatory-indicator">*</span>',
      AzureAd: 'Copy the App federation metadata URL and paste it here <span class="mandatory-indicator">*</span>',
      Google: 'Paste the content of the downloaded Metadata file here <span class="mandatory-indicator">*</span>',
    },
    invalidInputError: {
      Okta: 'Invalid URL',
      AzureAd: 'Invalid URL',
      Google: 'Invalid XML format',
    },
    providerWarning: 'You must select at least one provider to configure SSO',
    selectProviderDropdownLabel: 'Select identity provider',
    interProviderInformation: 'Provider information',
    seeGuide: 'See documentation in our guide',
    metadataTextareaPlaceholder: 'Paste app federation metadata here...',
    metadataInputPlaceholder: 'Paste Metadata here...',
  },
  permissions: {
    disableAppsTitle: 'Sources',
    disableAppsMessage: 'Allow members to connect sources',
    selectAppsMessage: 'Select the sources to enable connection for your workspace members',
    selectAppsWarning: 'No apps selected. Members won’t be able to connect sources until at least one is selected.',
    generalAsistantsTitle: 'General Assistants',
    allowAsistantsConnectedSources: 'Allow creating Assistants using connected sources',
    allowAsistantsPublicSources: 'Allow creating Assistants using public sources ',
    allowAsistantsAgentic: 'Allow creating Next-Gen Assistant',
    allowApiKeysTitle: 'API Keys',
    allowApiKeys: 'Allow creating API Keys',
    dropdownOptions: [
      {
        name: 'Only Admins',
        code: Workspace.AccessLevel.AdminsOnly,
        value: Workspace.AccessLevel.AdminsOnly,
      },
      {
        name: 'Everyone in workspace',
        code: Workspace.AccessLevel.Everyone,
        value: Workspace.AccessLevel.Everyone,
      },
    ],
  },
};
